import api from '@/libs/axios'


export default {
  async create(payload) {
    const response = await api.post('/admin/noti-triggers', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/noti-triggers', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/noti-triggers', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    let response = await api.get('/admin/noti-triggers', {
      params,
    })
    return response.data.data
  },
  async get(params) {
    let response = await api.get('/admin/noti-triggers/detail', {
      params,
    })
    return response.data.data.document || null
  },
}
